import React, {useState} from 'react';
import {Avatar, Box, Grid, Tab, Tabs} from "@mui/material";
import LimitesCLG from "./CLG/LimitesCLG";
import LimitesCLFB from "./CLFB/LimitesCLFB";
import LimitesContraparte from "./contraparte/LimitesContraparte";
import {z} from "../../lib";
import {useForm, useWatch} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {HttpSystemsNewByGroup} from "../../http/group/httpSystemsNewByGroup";
import {EntityWithIdAndDescriptionFields, EntityWithIdFields} from "../../types";
import {SistemaPrincipalFields} from "../../types/workflow/cache";
import { LimitesLCTC } from './LCTC/LimitesLCTC';
import { LimitesLCLS } from './LCLS/LimitesLCLS';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps): JSX.Element {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`limites-tabpanel-${index}`}
            aria-labelledby={`limites-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    {children}
                </Box>
            )}
        </div>
    );
}


function Limites(): JSX.Element {
    const [tabValue, setTabValue] = useState<number>(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number): void => {
        setTabValue(newValue);
    };

    return (
        <Box sx={{width: '100%'}}>
            <Grid container>
                <Grid item xs={12}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            aria-label="limites tabs"
                            variant="fullWidth"
                        >
                            <Tab label="Credit Limit Garantías"/>
                            <Tab label="Credit Limit Facilitation Book"/>
                            <Tab label="Contraparte"/>
                            <Tab label="LCTC"/>
                            <Tab label="LCLS"/>
                        </Tabs>
                    </Box>

                    <TabPanel value={tabValue} index={0}>
                        <LimitesCLG/>
                    </TabPanel>

                    <TabPanel value={tabValue} index={1}>
                        <LimitesCLFB/>
                    </TabPanel>

                    <TabPanel value={tabValue} index={2}>
                        <LimitesContraparte/>
                    </TabPanel>

                    <TabPanel value={tabValue} index={3}>
                        <LimitesLCTC/>
                    </TabPanel>

                    <TabPanel value={tabValue} index={4}>
                        <LimitesLCLS/>
                    </TabPanel>
                </Grid>
            </Grid>


        </Box>
    );
}

export default Limites;